import React from "react";

const S360Link = ( props ) =>
{
    const btnClass = props.flashBg ? ' generic-button blink-bg' : 'generic-button';

    return (
        <div className='icon-content'>
            <div className='selection-layout'>
                <a href={props.url} target={props.target} title={props.title}>
                    <div className={btnClass}>
                        <div className='shortcut'>
                            <div>{props.title}</div>
                            <i className={ props.icon }></i>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default S360Link ;